const bbCodeParsed = (
  text: string,
  brandText?: string,
  modelName?: string
): string => {
  let parsedContent: string = text;

  parsedContent = parsedContent.replace(/{modelText}/g, modelName || '');

  parsedContent = parsedContent.replace(
    /\[url=(.*?)\](.*?)\[\/url\]/g,
    `<a href="$1" target="_blank" style="color: #505050">$2</a>`
  );

  parsedContent = parsedContent.replace(/\[b\](.*?)\[\/b\]/g, '<b>$1</b>');

  parsedContent = parsedContent.replace(/\[i\](.*?)\[\/i\]/g, '<i>$1</i>');

  parsedContent = parsedContent.replace(/{brandText}/g, brandText || '');

  return parsedContent;
};

export default bbCodeParsed;
